import React, { useState, useRef, useEffect } from 'react';
import { OutlinedInput, InputAdornment } from '@mui/material';
import {
  InputSearchIcon,
  CloseIcon
} from '@components/icons/svg-icon.tsx';

interface MediaLibrarySearchProps {
  onSearchChange: (value: string) => void;
  value?: string;
  placeholder?: string;
}

const MediaLibrarySearch: React.FC<MediaLibrarySearchProps> = ({
  onSearchChange,
  value = '',
  placeholder = 'Search...'
}) => {
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    setInputValue(newValue);
    onSearchChange(newValue);
  };

  const handleClearInput = () => {
    setInputValue('');
    onSearchChange('');
  };

  return (
    <div className="flex items-center">
      <OutlinedInput
        sx={{
          width: '308px',
          '& .MuiOutlinedInput-notchedOutline': {
            borderRadius: '30px'
          },
          '& .MuiInputBase-input': {
            padding: '8px 10px',
            fontSize: '14px'
          }
        }}
        placeholder={placeholder}
        value={inputValue}
        onChange={handleInputChange}
        startAdornment={
          <InputAdornment position="start">
            <InputSearchIcon
              fill="var(--blue-4)"
              className="!w-[16px] !h-[16px] max-lg-xl:!w-[14px] max-lg-xl:!h-[14px]"
            />
          </InputAdornment>
        }
        endAdornment={
          inputValue ? (
            <InputAdornment position="end">
              <button
                className="cursor-pointer px-3 flex justify-center items-center"
                onClick={handleClearInput}
                type="button"
                aria-label="Clear search"
              >
                <CloseIcon
                  stroke="var(--primary)"
                  className="!w-[14px] !h-[14px] -mr-2"
                />
              </button>
            </InputAdornment>
          ) : null
        }
      />
    </div>
  );
};

export default MediaLibrarySearch;
